import * as React from "react"
import { useEffect } from "react";
import { batch } from "@preact/signals-react";
import { Box } from "@mui/material"

import { CommonFilters } from "@components";
import {COMMON_FILTER_KEYS, GROUPED_BY, SHARE_OF_SEARCH_ROUTES} from "@constants";
import { useAppDefaultFilters } from "@hooks";
import { PRODUCT_PAGE_ROUTES } from "@constants";
import {isLoadingCommonFilters, isSystemBusy, splitKpi, vision} from "@signals";
import { productPagesKpiIsEmpty } from "./@signals";
import { useProductPageKpiRoleConfig } from "./@hooks";



export default function ProductPagesKpiFilters() {

	const { isMarketplacesUser } = useProductPageKpiRoleConfig()
	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(PRODUCT_PAGE_ROUTES.KPIS_ID, PRODUCT_PAGE_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	const splitKpiExcludeOptions = () => {
		const options = []
		if (vision.value === GROUPED_BY.COUNTRY) options.push(GROUPED_BY.COUNTRY)
		if (vision.value === GROUPED_BY.BRAND) options.push(GROUPED_BY.BRAND)
		if (!isMarketplacesUser) options.push(GROUPED_BY.SELLER)
		options.push(GROUPED_BY.SKU)
		return options
	}

	return <Box data-tour="pp-kpi-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			favFiltersOnlyLine: true, skuGroup: true,
			splitKpi: true, seller: isMarketplacesUser
		}}
		compProps={{
			favFilters: {
				grid: { md: 3 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.SPLIT_KPI,
					COMMON_FILTER_KEYS.SELLERS
				],
				dashboardKey: PRODUCT_PAGE_ROUTES.KPIS_ID
			},
			actions: { grid: { md: 2, xs: 1, sm: 1 } },
			sku: { grid: { xs: 12, md: isMarketplacesUser ? 4 : 6 } },
			splitKpi: {
				grid: { xs: 10, md: 10, sm: 10 },
				excludeOptions: [GROUPED_BY.SKU, GROUPED_BY.SELLER]
			}
		}}
		onSubmit={() => batch(() => {
			isLoadingCommonFilters.value = true
			isSystemBusy.value = false
			productPagesKpiIsEmpty.value = false
		})}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}